import {useAtom} from "jotai";
import {nextSessionAtom} from "../store/sessionAtom";

export const useUserLoggedIn = () => {
  const [sessionAtom] = useAtom(nextSessionAtom)
  const {status} = sessionAtom;

  return status=="authenticated";
}
